<template>
	<v-layout 
		align-center 
		justify-center
		fill-height
	>
		<v-flex
			md6
			xl4
		>
			<v-card
				flat
				dark
				color="#00001B"
				elevation="20"
			>
				<v-container 
					grid-list-md 
					text-xs-center
				>
					<v-layout 
						row 
						wrap
					>
						<v-flex 
							xs12
						>
							<!-- 
								<h1
								class="title"
							>
								sign-in
							</h1>
							<img src="@/assets/logo-login.jpg" alt="" width="100%"> 
							-->
							<v-icon
								size="50"
							>
								fas fa-user-alt
							</v-icon>
							<div class="">Login</div>
							<v-form
								ref="form"
								v-model="valid"
								lazy-validation
							>
								<v-text-field
									v-model="credentials.email"
									color="warning"
									prepend-icon="fas fa-envelope"
									:rules="emailRules"
									label="E-mail"
									required
								/>

								<v-text-field
									v-model="credentials.password"
									color="warning"
									prepend-icon="fas fa-key"
									:rules="passwordRules"
									label="Password"
									type="password"
									required
								/>

								<v-card-actions>
									<v-spacer />
									<v-btn 
										flat
										:disabled="!valid"
										color="error" 
										@click="dismiss ()"
									>
										Dismiss
									</v-btn>

									<v-btn 
										flat
										:disabled="!valid"
										color="success" 
										@click="doLogin ()"
									>
										Verify
									</v-btn>
								</v-card-actions>
								<v-divider />
										
								<v-layout 
									column
									justify-center
									class="sign-in-container"
								>
									<span class="sign-disclaimer"> Do not have an account yet? </span> 
									<button
										class="sign-button"
										@click.prevent="showSignup ()"
									>
										sign-up
									</button>
								</v-layout>
							</v-form>
						</v-flex>
					</v-layout>
				</v-container>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'

export default {
	name:'Login',
	data () {
		return {
			alertLabel: '',
			valid: true,
			credentials: {
				email: '',
				password: ''
			},
			passwordRules: [
				// v => !!v || 'E\' necessario inseire una password valida',
			],
			emailRules: [
				// v => !!v || 'E\' necessario inseire un email valida',
				// v => /.+@.+/.test (v) || 'E\' necessario inseire un email valida'
			]
		}
	},

	computed: {
		...mapGetters (['user'])
	},

	watch: {
		'user': function (user) {
			if (!user)
				return
			console.log ('Login ok with:', user)

			if (user.emailVerified) {
				this.$router.push ({ path: '/' })
			}
		}
	},

	methods: {
		...mapMutations (['dismissAuthentication','showSignUpForm', 'SHOW_ALERT']),
		...mapActions (['authenticateUser']),
		showSignup: function () {
			this.showSignUpForm (true)
		},
		dismiss: function () {
			this.dismissAuthentication ()
		},
		doLogin: async function () {
			await this.authenticateUser (this.credentials)
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/index.scss';

.title {
	color: $primary !important;
	text-transform: uppercase;
	font-size: 22px !important;
	font-weight: 400;
	margin: 10%;
}

.login-field {
	border-radius: 100px;
}

.sign-button {
	color: white;
	margin-left: 1%;
	font-size: 16px;
	text-transform: uppercase;
	&:hover {
		text-decoration: underline;
	}
}

.sign-disclaimer {
	font-size: 16px;
	color: rgba(255, 255, 255, 0.8);

}

.sign-in-container {
	margin-top: 5% !important;
}

</style>
